export const SITE_CHANGE_MESSAGE =
  'I understand that changing the site the license is assigned to will result in any users on the previous site losing their access.'



// WEBPACK FOOTER //
// ./src/components/EditLicenseModalSiteChangeConfirmation/constant.js